// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-contact-dialog-container textarea,
.dialog-container textarea {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 357.5%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 13px;
  resize: none;
  width: 100%;
  padding: 8px 12px;
}
.signup-contact-dialog-container textarea::placeholder,
.dialog-container textarea::placeholder {
  font-size: 10px;
}
.signup-contact-dialog-container .dialog-action .action-btn,
.dialog-container .dialog-action .action-btn {
  border-radius: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 7.5px 20px;
  color: #ffffff;
  border: 0px;
}
.signup-contact-dialog-container .dialog-action .primary-action-btn,
.dialog-container .dialog-action .primary-action-btn {
  background: #225ea8;
}
.signup-contact-dialog-container .dialog-action .secondary-action-btn,
.dialog-container .dialog-action .secondary-action-btn {
  background: grey !important;
}

.dialog-container-reports .MuiDialog-paper {
  background-color: #469473;
  background-repeat: no-repeat;
}
.dialog-container-reports .dialog-action button {
  margin: 15px 50px 0px 50px;
  background: radial-gradient(58.52% 47.51% at 56.65% 47.58%, #059baf 0%, #007080 100%);
  border: 2px solid #ffffff;
  border-radius: 9px;
  height: 25px;
  color: white;
  font-size: 12px;
}
.dialog-container-reports .dialog-action .secondary-action-btn {
  background: grey !important;
}

.signup-contact-dialog-container .MuiDialog-paper,
.dialog-container .MuiDialog-paper {
  background-color: #80b368 !important;
  max-width: 35%;
  margin: auto 7% auto auto;
  width: 100%;
  border: 1px solid #fff;
  border-radius: 0px;
}

.signup-contact-dialog-container input {
  background: linear-gradient(180deg, #ffffff 0%, #e9e9e9 100%) !important;
}

.signup-body-container .signup-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: calc(100% + 0px);
  margin: 0px;
}

.signup-body-container .signup-form-grid .MuiGrid-root.MuiGrid-item {
  max-width: 100%;
  width: 100%;
}

.signup-contact-dialog-container .MuiDialog-scrollPaper .signup-title-container .signup-title-close-icon {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

.signup-contact-dialog-container .MuiDialog-scrollPaper .signup-title-container .signup-title {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  padding-bottom: 10px;
  margin-bottom: 12px;
}

.signup-contact-dialog-container .MuiDialogActions-root.dialog-action {
  padding: 10px 30px;
}`, "",{"version":3,"sources":["webpack://./src/styles/controls/dialog.scss"],"names":[],"mappings":"AAOE;;EAIE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,8EAAA;EAKA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAZJ;AALI;;EACE,eAAA;AAQN;AAWI;;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AARN;AAUI;;EACE,mBAAA;AAPN;AASI;;EACE,2BAAA;AANN;;AAYE;EACE,yBAAA;EACA,4BAAA;AATJ;AAYI;EACE,0BAAA;EACA,qFAAA;EAKA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAdN;AAgBI;EACE,2BAAA;AAdN;;AAmBA;;EAEE,oCAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,wEAAA;AAhBF;;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;AAfF;;AAiBA;EACE,eAAA;EACA,WAAA;AAdF;;AAgBA;EAIE,WAAA;EACA,eAAA;EACA,eAAA;AAhBF;;AAkBA;EAIE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,kBAAA;AAlBF","sourcesContent":[".signup-contact-dialog-container,\r\n.dialog-container {\r\n  // .MuiDialog-paper {\r\n  //   background-color: #e0e0e0;\r\n  //   background-image: url(../../images/loginBg.png);\r\n  //   background-repeat: no-repeat;\r\n  // }\r\n  textarea {\r\n    &::placeholder {\r\n      font-size: 10px;\r\n    }\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    background: linear-gradient(\r\n      180deg,\r\n      #ffffff 0%,\r\n      rgba(255, 255, 255, 0) 357.5%\r\n    );\r\n    border: 1px solid #ffffff;\r\n    box-sizing: border-box;\r\n    border-radius: 13px;\r\n    resize: none;\r\n    width: 100%;\r\n    padding: 8px 12px;\r\n  }\r\n  .dialog-action {\r\n    .action-btn {\r\n      border-radius: 5px;\r\n      font-style: normal;\r\n      font-weight: 400;\r\n      font-size: 14px;\r\n      padding: 7.5px 20px;\r\n      color: #ffffff;\r\n      border: 0px;\r\n    }\r\n    .primary-action-btn {\r\n      background: #225ea8;\r\n    }\r\n    .secondary-action-btn {\r\n      background: grey !important;\r\n    }\r\n  }\r\n}\r\n\r\n.dialog-container-reports {\r\n  .MuiDialog-paper {\r\n    background-color: #469473;\r\n    background-repeat: no-repeat;\r\n  }\r\n  .dialog-action {\r\n    button {\r\n      margin: 15px 50px 0px 50px;\r\n      background: radial-gradient(\r\n        58.52% 47.51% at 56.65% 47.58%,\r\n        #059baf 0%,\r\n        #007080 100%\r\n      );\r\n      border: 2px solid #ffffff;\r\n      border-radius: 9px;\r\n      height: 25px;\r\n      color: white;\r\n      font-size: 12px;\r\n    }\r\n    .secondary-action-btn {\r\n      background: grey !important;\r\n    }\r\n  }\r\n}\r\n\r\n.signup-contact-dialog-container .MuiDialog-paper,\r\n.dialog-container .MuiDialog-paper {\r\n  background-color: #80b368 !important;\r\n  max-width: 35%;\r\n  margin: auto 7% auto auto;\r\n  width: 100%;\r\n  border: 1px solid #fff;\r\n  border-radius: 0px;\r\n}\r\n\r\n.signup-contact-dialog-container input {\r\n  background: linear-gradient(180deg, #ffffff 0%, #e9e9e9 100%) !important;\r\n}\r\n.signup-body-container .signup-form-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  width: calc(100% + 0px);\r\n  margin: 0px;\r\n}\r\n.signup-body-container .signup-form-grid .MuiGrid-root.MuiGrid-item {\r\n  max-width: 100%;\r\n  width: 100%;\r\n}\r\n.signup-contact-dialog-container\r\n  .MuiDialog-scrollPaper\r\n  .signup-title-container\r\n  .signup-title-close-icon {\r\n  color: #fff;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n}\r\n.signup-contact-dialog-container\r\n  .MuiDialog-scrollPaper\r\n  .signup-title-container\r\n  .signup-title {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: #fff;\r\n  padding-bottom: 10px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.signup-contact-dialog-container .MuiDialogActions-root.dialog-action {\r\n  padding: 10px 30px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
